import { supabase } from '@/integrations/supabase/client';
import { getCaptcha } from '@/lib/captcha';

interface SubscribeResult { success: boolean; error?: string }

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

// The protected Edge Function persists subscriptions in Supabase; no mail provider is required.
export async function subscribeToNewsletter(email: string): Promise<SubscribeResult> {
  if (!isValidEmail(email)) return { success: false, error: 'Email inválido' };
  try {
    const captcha = await getCaptcha('newsletter_subscribe');
    const { data, error } = await supabase.functions.invoke('subscribe-newsletter', {
      body: { consent_version: 'communications_v1', email: email.trim().toLowerCase(), captcha_token: captcha.token, captcha_provider: captcha.provider },
    });
    if (error || data?.success !== true) return { success: false, error: 'No se pudo confirmar la suscripción. Inténtalo de nuevo.' };
    if (data.simulated === true) return { success: true, simulated: true };
    return { success: true };
  } catch {
    return { success: false, error: 'No se pudo completar la verificación. Inténtalo de nuevo.' };
  }
}
